import {RaceStatusEnum} from './enums/raceStatusEnum';

export interface RaceDataModel {
    raceStartTime: string,
    raceId: number,
    windDirection: number,
    windSpeed: number,
    seaLevel: number,
    numberOfBoats: number,
    raceType: TypeOfRaceEnum | undefined,
    status: RaceStatusEnum | undefined,
    numberOfLegs: number,
    msec: number
}

export const enum TypeOfRaceEnum {
    None = 'None',
    Fleet = 'Fleet',
    Match = 'Match',
    Test = 'Test',
    Practice = 'Practice',
    Final = 'Final'
}
